<template>
  <div class="aontractManage-dialog ">
    <el-dialog :title="title"
               :visible.sync="drawerShow"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               width="900px"
               @close="colseDrawer()"
               class="colleague-dialog">
      <MyTable :tableData="tableData"
               :tableConfig="tableConfig"
               :height="tableHeight+'px'"
               :indexFlag="true">
        <template v-slot:index="slotData">
          {{
            slotData.scope.$index +
            1
          }}
        </template>

      </MyTable>
      <!-- <Pagination :total="total"
                  @getNewData="getPage"
                  ref="pagination" /> -->
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="colseDrawer()
            ">取 消</el-button>

      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from "@/components/Table";
export default {
  components: {
    MyTable,
  },
  props: {
    title: String,
    drawerShow: Boolean,
    operation: String,
    customerInfo: Array,
  },
  data () {
    return {
      submitLoading: false,
      drawer: false,
      tableData: [],
      tableHeight: 400,
      total: 0,
      tableConfig: [
      ],
    };
  },

  methods: {
    getPage (type) {
      this.tableData = this.customerInfo;
    },
    colseDrawer () {
      this.$emit("colseDrawer");
    },
  },
  watch: {
    drawerShow (val) {
      this.drawer = val;
      this.getPage();
      //标题包含企业或职位
      if (this.title.includes("企业") || this.title.includes("职位")) {
        this.tableConfig = [
          {
            field: "enterpriseShortName",
            label: "企业名称",
            width: 180,
            align: "center",
            flag: true,
          },
          {
            field: "positionName",
            label: "职位名称",
            minWidth: 160,
            align: "center",
            flag: true,

          },
        ]
      } else {
        this.tableConfig = [
          {
            field: "name",
            label: "姓名",
            minWidth: 160,
            align: "center",
            flag: true,
          },
          {
            field: "identityCard",
            label: "身份证",
            minWidth: 160,
            align: "center",
            flag: true,
          },
          {
            field: "phoneNumber",
            label: "手机号",
            minWidth: 120,
            align: "center",
            flag: true,
          },
          {
            field: "enterpriseShortName",
            label: "企业简称",
            width: 180,
            align: "center",
            flag: true,
          },
          {
            field: "applyPositionName",
            label: "职位名称",
            minWidth: 160,
            align: "center",
            flag: true,
          },
        ]
        this.getPage(2);
      }
    },
  },
};
</script>

<style lang="less">
.aontractManage-dialog {
  .form-item-block {
    width: 100% !important;
    .el-form-item__content {
      width: 82% !important;
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-form-item {
    width: 48%;
    .el-form-item__content {
      width: 56%;
    }
    .el-select {
      width: 100%;
    }
  }
}
</style>
